/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountDetailsDto } from '../models/AccountDetailsDto';
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { EntityModelResponseContainerAccountDetailsDto } from '../models/EntityModelResponseContainerAccountDetailsDto';
import type { EntityModelResponseContainerAdminUserDto } from '../models/EntityModelResponseContainerAdminUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountManagementControllerService {
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static updateRegAccountChangePassword({
        requestBody,
    }: {
        requestBody: ChangePasswordDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/account/change_pw',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerAccountDetailsDto OK
     * @throws ApiError
     */
    public static getAccountDetails(): CancelablePromise<EntityModelResponseContainerAccountDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/account/details',
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static updateAccountDetails({
        requestBody,
    }: {
        requestBody: AccountDetailsDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/account/details',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static qrcodegen({
        code,
    }: {
        code: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/account/qr',
            query: {
                'code': code,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getVerifyOtpCode({
        xOtpCode,
    }: {
        xOtpCode: string,
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/account/verify',
            headers: {
                'X-OTP-CODE': xOtpCode,
            },
        });
    }
}
